export const getKeyByValue = (obj: any, value: any) => {
  return Object.keys(obj).find((key) => obj[key] === value);
};
